export enum FormStatusEnum {
  New = 1,
  InProcess = 2,
  CompletedAwaitingApproval = 4,
  Approved = 8,
  ApprovalDenied = 16,
  Cancelled = 32,
  Withdrawn = 64,
  AwaitingApproval = 128,
  IsActive = New | InProcess | CompletedAwaitingApproval | ApprovalDenied,
  Inactive = Cancelled | Withdrawn,
}
